const BREAKPOINTS = {
  xl: 1200,
  lg: 992,
  md: 768,
  // use this function only where useScreenSize hook is not possible to use
  isLarge: function () { return window.screen.width >= this.lg }
}

module.exports = { BREAKPOINTS }